import { Component, ElementRef, OnInit } from '@angular/core';

import { HomeWidget } from '../dashboard-widget.utils';

@Component({
  selector: 'app-line-graph-widget',
  templateUrl: './line-graph-widget.component.html',
  styleUrls: ['./line-graph-widget.component.scss']
})
export class LineGraphWidgetComponent extends HomeWidget implements OnInit {
  constructor(elRef: ElementRef) {
    super(elRef);
  }

  ngOnInit(): void {}
}
